import React from "react";
import "./skeleton.css";

/**
 * SkeletonCard — Skeleton placeholder for a product card.
 * Mirrors the layout of MatchCard (thumbnail + title + subtitle + price).
 *
 * @param {Object} props
 * @param {number} [props.index=0] - Index for stagger animation delay
 */
export default function SkeletonCard({ index = 0 }) {
    const staggerClass = `skeleton-stagger-${Math.min(index + 1, 10)}`;

    return (
        <div className="skeleton-card" role="presentation">
            {/* Thumbnail */}
            <div
                className={`skeleton-bone skeleton-rounded-xl skeleton-card-thumbnail ${staggerClass}`}
            />
            {/* Text lines */}
            <div className="skeleton-card-body">
                <div className={`skeleton-bone skeleton-card-title ${staggerClass}`} />
                <div className={`skeleton-bone skeleton-card-subtitle ${staggerClass}`} />
                <div className={`skeleton-bone skeleton-card-price ${staggerClass}`} />
            </div>
        </div>
    );
}
